<ng-template #content_config_machine let-offcanvas>
    <div class="{{localService.selectedLanguageCode}}">
        <div class="side_popup_header">
            <span>{{localService.languageContent.table.action + ' - ' + title}}</span>
            <button class="button_icon" (click)="onCloseTrigger()">close</button>
        </div>
        <div class="side_popup_body" style="max-height: calc(100vh - 130px);" *ngIf="item">
            <div class="row">
                <div class="col-12">
                    <div>
                        <label for="machine_name">Machine Name *</label>
                    </div>
                    <div>
                        <input type="text" id="machine_name" [(ngModel)]="item.item.Title">
                    </div>
                </div>
            </div>
            <div class="row">
                <div class="col-12">
                    <label style="font-weight: normal; margin-left: 15px;">
                        <input type="checkbox" [(ngModel)]="item.item.IsActive" />
                        <span class="normal_color">Is Active?</span>
                    </label>
                </div>
            </div>
            <div class="row">
                <div class="col-12">
                    <div>
                        <label>Network Type *</label>
                    </div>
                    <div>
                        <ngx-select [diasabled]="id && id.length > 5"
                            style="position: absolute; width: calc(100% - 20px);" *ngIf="networkTypes"
                            [(ngModel)]="item.item.NetworkType" [optionValueField]="'key'" [optionTextField]="'value'"
                            [items]="networkTypes" [noAutoComplete]="true">
                        </ngx-select>
                    </div>
                </div>
            </div>
            <div class="row" style="margin-top: 60px;">
                <div class="col-12">
                    <div>
                        <label for="network_url">Network URL *</label>
                    </div>
                    <div>
                        <input type="text" id="network_url" [(ngModel)]="item.item.NetworkUrl">
                    </div>
                </div>
            </div>
            <div class="row" *ngIf="item.item.NetworkType == '1'">
                <div>
                    <label>Temporary Directory :</label>
                </div>
                <div>
                    <input type="text" [(ngModel)]="item.item.TemporaryFolderPath" />
                </div>
            </div>
            <div *ngIf="item.item.NetworkType == '1'">
                <div class="box" *ngIf="currentPriterNames.length > 0">
                    <h5 style="text-align: center;">Selected Printers</h5>
                    <div *ngFor="let item of currentPriterNames">
                        <label style="font-weight: normal; margin-left: 15px;">
                            <input type="checkbox" [(ngModel)]="item.isSelected" />
                            <span class="normal_color">{{item.value}}</span>
                        </label>
                    </div>
                </div>
                <div class="row">
                    <div class="col-12" style="text-align: center;">
                        <button type="button" class="btn btn-primary" (click)="onGetPrinterNames()">Get Printer
                            Names</button>
                    </div>
                </div>
                <div class="box" *ngIf="newPriterNames.length > 0">
                    <h5 style="text-align: center;">New Printers</h5>
                    <div *ngFor="let item of newPriterNames">
                        <label style="font-weight: normal; margin-left: 15px;">
                            <input type="checkbox" [(ngModel)]="item.isSelected" />
                            <span class="normal_color">{{item.value}}</span>
                        </label>
                    </div>
                </div>
            </div>
            <div *ngIf="item.item.NetworkType == '2'">
                <div class="row">
                    <div class="col-12">
                        <label for="current_machine">Current Machine *: </label>
                        <span>{{item.weightMachinePortPath}}</span>
                    </div>
                </div>
                <div class="row">
                    <div class="col-12" style="text-align: center;">
                        <button type="button" class="btn btn-primary" (click)="onGetMachineNames()">Get Machine
                            Names</button>
                    </div>
                </div>
                <div class="box" *ngIf="newMachineNames.length > 0">
                    <h5 style="text-align: center;">Available Machines</h5>
                    <div *ngFor="let item of newMachineNames">
                        <label style="margin-left:15px;font-weight:normal;">
                            <input type="radio" name="settings" [checked]="item.isSelected"
                                (click)="onChecked(item.key)">
                            <span>&nbsp;{{item.value}}&nbsp;({{item.s_value}})</span>
                        </label>
                    </div>
                </div>
            </div>
        </div>
        <div class="side_popup_footer">
            <div class="row">
                <div class="col-12">
                    <button type="button" class="btn btn-primary" (click)="onAction(1)">{{id && id.length > 5 ?
                        localService.languageContent.common.save :
                        localService.languageContent.common.create}}</button>
                </div>
            </div>
        </div>
    </div>
</ng-template>